/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_TaglineInputs */



/**
* | output |
* | --- |
* | "Built with Fury. Maintained with Calm." |
*
* @param {Layout_Header_TaglineInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_tagline = /** @type {((inputs?: Layout_Header_TaglineInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_TaglineInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit Furor gebaut. Mit Ruhe gepflegt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bâti avec Fureur. Entretenu avec Calme.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("以炽烈铸就，以翠意守护。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("以狂怒打造，以止靜維護。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("분노로 만들고, 평정으로 가꿉니다.")
	return /** @type {LocalizedString} */ ("Built with Fury. Maintained with Calm.")
});